<template>
  <section class="analyze-container">
    <header class="analyze-header">
      <!-- <h1 class="title">Ditch the Resume. Get a Teamwrkr Profile!</h1> -->
      <!-- <p class="subtitle">A dynamic record of your experience and ambitions, built to evolve as you do.</p> -->
      <p class="body">Let's start by you telling me what you do. Your role, the tools you use, and the projects or wins you're proud of.</p>
      <p class="body bold">If you can paste text from your resume that would be great! Or just start typing. I'll organize it for you!</p>
    </header>

    <div class="analyze-content">
      <b-field>
        <b-input
        v-model="resumeText"
        type="textarea"
        placeholder="Start typing about your work, skills, and accomplishments.

If you're not sure where to begin, just describe what you do day-to-day.

If you have your current resume, paste the text here!"
        rows="10"
        ></b-input>
      </b-field>
      <p class="body">You’ll be able to review and edit your Profile later.</p>
      <div class="button-group">
        <b-button
          type="is-primary"
          :disabled="!resumeText.trim()"
          :loading="loading"
          @click="submitResume"
        >
        Build My Profile!
      </b-button>
      <!-- <b-button
          type="is-secondary"
          :loading="loading"
          @click="cancel"
        >
        Cancel
      </b-button> -->
    </div>
    <p v-if="error" class="error-msg">{{ error }}</p>
    </div>
    <OnboardingSteps :currentStep="1" />
  </section>
</template>

<script>
import { useAnalyzeStore } from '../stores/analyzeStore'
import OnboardingSteps from '@/components/OnboardingSteps.vue';

export default {
  name: 'AnalyzeIntro',
  components: {
    OnboardingSteps,
  },
  created() {
    if (this.$cookies.isKey("teamwrkr-token")) {
      this.$router.push('/');
    }
    this.analyzeStore = useAnalyzeStore()
    if (this.$route.query.user) {
      this.fetchAndRehydrateUserData(this.$route.query.user).then(userData => {
        if (userData) {
          this.analyzeStore.setUser(userData);
        }
      });
    }
  },
  data() {
    return {
      resumeText: '',
      loading: false,
      error: ''
    };
  },
  methods: {
    async fetchAndRehydrateUserData(userId) {
      console.log('Fetching user data for ID:', userId);
      try {
        const response = await this.axios.get(
          `${process.env.VUE_APP_API_URL}/users/${userId}`
        );
        return response.data;
      } catch (err) {
        console.error('Error fetching user data:', err);
        return null;
      }
    },
    async submitResume() {
      this.analyzeStore.setResumeText(this.resumeText);
      this.loading = true;
      this.error = '';
      try {
        const response = await this.axios.post(
          `${process.env.VUE_APP_API_URL}/users/analyze-resume`,
          { resumeText: this.resumeText, user: this.analyzeStore.user },
          { headers: { Authorization: `Onboarding ${this.analyzeStore.onboardingToken}` } }
        );
        console.log("STEP 1 ANALYSIS RESPONSE:", response.data);

        this.analyzeStore.setAnalysis(response.data);
        this.calculateMissingFields();
        this.$router.push({ name: 'AnalyzeDetails' });
      } catch (err) {
        this.error = err?.response?.data?.message || 'Could not analyze resume. Please try again.';
      } finally {
        this.loading = false;
      }
    },
    calculateMissingFields() {
      // ANALYSIS fields
      if (!this.analyzeStore.analysis.accomplishments.length) {
        this.analyzeStore.missingFields.push('Career Accomplishments');
      }
      if (!this.analyzeStore.analysis.certifications.length) {
        this.analyzeStore.missingFields.push('Certifications');
      }
      if (!this.analyzeStore.analysis.skills.length) {
        this.analyzeStore.missingFields.push('Key Skills');
      }
      if (!this.analyzeStore.analysis.softSkills.length) {
        this.analyzeStore.missingFields.push('Soft Skills');
      }
      if (!this.analyzeStore.analysis.teamPreferences) {
        this.analyzeStore.missingFields.push('Team Preferences');
      }
      if (!this.analyzeStore.analysis.workPreferences) {
        this.analyzeStore.missingFields.push('Work Preferences');
      }
      if (!this.analyzeStore.analysis.values || !this.analyzeStore.analysis.values.length) {
        this.analyzeStore.missingFields.push('Core Values');
      }

      // WORK HISTORY fields
      if (!this.analyzeStore.workHistory.length || this.analyzeStore.workHistory.length === 1) {
        this.analyzeStore.setMissingWorkHistory(true);
      }

      console.log('MISSING FIELDS:', this.analyzeStore.missingFields);
    },
    cancel() {
      // this.$router.push('/');
      console.log('Cancel button clicked');
    }
  }
};
</script>

<style lang="scss" scoped>
.analyze-container {
  background: $color-surface-alt;
  border-radius: 1.2rem;
  box-shadow: 0 4px 32px rgba(170, 118, 214, 0.07);
  padding: 2.5rem 2rem 2rem 2rem;
  max-width: 700px;
  margin: 2.5rem auto;
  color: $color-text;
}

.analyze-header {
  margin-bottom: 2rem;
  text-align: center;

  .title {
    font-size: 2rem;
    font-weight: 700;
    color: $color-primary;
    margin-bottom: 1.7rem;
  }
  .subtitle {
    font-size: 1.15rem;
    color: $color-text-muted;
    margin-bottom: 0.7rem;
    font-style: italic;
  }
  .body {
    font-size: 1.05rem;
    color: $color-text;
    margin-bottom: 0.4rem;
    &.bold {
      font-weight: 600;
    }
  }
}

.analyze-content {
  background: $color-surface;
  border-radius: 1rem;
  box-shadow: 0 2px 12px rgba(170, 118, 214, 0.05);
  padding: 2rem 1.2rem 1.5rem 1.2rem;
  margin-bottom: 2rem;
}

.b-field {
  margin-bottom: 1.5rem;
}

.b-input textarea {
  background: $color-surface-alt;
  border: 1.5px solid $color-primary;
  border-radius: 0.7rem;
  color: $color-text;
  font-size: 1.08rem;
  padding: 1rem;
  transition: border-color 0.18s;
  &:focus {
    border-color: $color-accent;
    outline: none;
  }
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 1.2rem;
}

.b-button {
  border-radius: 0.7rem;
  font-weight: 700;
  font-size: 1.08rem;
  border: none;
  box-shadow: 0 2px 8px rgba(170, 118, 214, 0.07);
  &.is-primary {
    background: $color-primary;
    color: $color-surface;
    transition: background 0.18s, color 0.18s;
    &:hover, &:focus {
      background: $color-accent;
      color: $color-surface;
    }
  }
  &.is-secondary {
    background: $color-surface-soft;
    color: $color-primary;
    &:hover, &:focus {
      background: $color-border;
      color: $color-text;
    }
  }
}

.error-msg {
  color: $color-accent;
  font-weight: 600;
  margin-top: 1rem;
}

@media screen and (max-width: 700px) {
  .analyze-container {
    padding: 1.2rem 0.5rem;
    max-width: 99vw;
  }
  .analyze-content {
    padding: 1rem 0.3rem;
  }
}
</style>
